const PRODUCT = process.env.REACT_APP_PRODUCT;
const IS_STRATUM_FAMILY = PRODUCT === "STRATUM" || PRODUCT === "DANUBE";

const IMAGE_PATH =
  process.env.PUBLIC_URL +
  `${
    PRODUCT === "STRATUM"
      ? "/images/stratum/"
      : PRODUCT === "DANUBE"
      ? "/images/danube/"
      : "/images/"
  }`;

const BRAND_NAME_BY_PRODUCT = {
  ANACITY: "Anacity",
  STRATUM: "Stratum",
  DANUBE: "Danube",
};

const NAV_LOGO_BY_PRODUCT = {
  ANACITY: "AnacityLogo.svg",
  STRATUM: "StratumLogo.svg",
  DANUBE: "DanubeLogo.svg",
};

const FOOTER_LOGO_BY_PRODUCT = {
  ANACITY: "anacityFooteLogo.png",
  STRATUM: "anacityFooteLogo.png",
  DANUBE: "DanubeFooterLogo.png",
};

const BRAND_NAME = BRAND_NAME_BY_PRODUCT[PRODUCT] || "Anacity";
const NAV_LOGO = IMAGE_PATH + (NAV_LOGO_BY_PRODUCT[PRODUCT] || "AnacityLogo.svg");
const FOOTER_LOGO =
  IMAGE_PATH + (FOOTER_LOGO_BY_PRODUCT[PRODUCT] || "anacityFooteLogo.png");

const FAVICON_BY_PRODUCT = {
  ANACITY: "titleLogo.svg",
  STRATUM: "titleLogo.svg",
  DANUBE: "DanubeLogo.svg",
};

const FAVICON = IMAGE_PATH + (FAVICON_BY_PRODUCT[PRODUCT] || "titleLogo.svg");

const SUB_LOGO_BY_PRODUCT = {
  ANACITY: "subLogo.png",
  STRATUM: "subLogo.png",
  DANUBE: "DanubeLogo.png",
};

const SUB_LOGO = IMAGE_PATH + (SUB_LOGO_BY_PRODUCT[PRODUCT] || "subLogo.png");

export { BRAND_NAME, FOOTER_LOGO, IMAGE_PATH, NAV_LOGO, PRODUCT, FAVICON, SUB_LOGO };
